export default "__VITE_ASSET__d837554b__"